import { GET_CONSOLIDATE } from './../constants';
import { handleActions } from "redux-actions"


export const consolidates  = handleActions(
  {
    [ GET_CONSOLIDATE ]: (state, action) => {
      let dataReturn = {}
      if (action.payload.name ==='Timeout') {
        dataReturn = state
      } else
      if (action.payload.error ) {
        dataReturn = state
      } else {
        //let arrResult = arrayhierarchy(action.payload.data, ['AHORRO', 'CORRESPONSALIA', 'AHORRO MENORES DE EDAD', 'CERTIFICADOS DE APORTACION', 'AHORRO PROGRAMADO'], 'Tipo')
        // console.log(arrResult)
        dataReturn = {
            cuentas : (action.payload.data.cuentas) ? action.payload.data.cuentas : [],
            depositosAPlazo : (action.payload.data.depositosAPlazo) ? action.payload.data.depositosAPlazo : [],
            prestamos : (action.payload.data.prestamos) ? action.payload.data.prestamos : []
        }
      }
      return dataReturn
    },
  }, {
    cuentas : [],
    depositosAPlazo : [],
    prestamos : []
  }
)